<div *ngIf="englishMarketChartData">
    <h4>Bookings</h4>
    <p-chart #chart type="line" [data]="englishMarketChartData" width="700px" height="500px"
        [responsive]="false"></p-chart>

    <h4>Duration (days)</h4>
    <div *ngIf="englishMarketChartData">
        <p-chart #chart type="line" [data]="englishMarketDurationChartData" width="700px" height="500px"
            [responsive]="false"></p-chart>
    </div>
</div>